module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.13763/images/gauge.svg"